/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/BuyerCompanyReportTable/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import styles from "./index.module.css";

import { useTranslation } from "react-i18next";

const BuyerCompanyReportTable = ({ buyerCompany }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.usersTableContainer}>
      {/* Desktop/Laptop Table View */}
      <div className={styles.desktopView}>
        <span className={styles.companyNameText}>
          {buyerCompany.nombreComercial}
        </span>
        <table className={styles.companyTable}>
          <thead>
            <tr>
              <th className={styles.tableNameHeader}>
                {t("pages.reports.user")}
              </th>
              <th className={styles.companyNameHeader}>
                {t("pages.reports.email")}
              </th>
              <th className={styles.positionHeader}>
                {t("pages.reports.position")}
              </th>
              <th className={styles.phoneHeader}>{t("pages.reports.phone")}</th>
              <th className={styles.statusHeader}>
                {t("pages.reports.status")}
              </th>
              <th className={styles.dateHeader}>
                {t("pages.reports.deactivationDate")}
              </th>
            </tr>
          </thead>
          <tbody>
            {buyerCompany.customerCompanyUsers.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: "center", padding: "8px" }}>
                  {t("pages.reports.noUsersForThisCompany")}
                </td>
              </tr>
            ) : (
              buyerCompany.customerCompanyUsers.map((user, index) => (
                <tr key={index}>
                  <td className={`${styles.tableNameData}`}>{user.nombre}</td>
                  <td className={`${styles.companyNameData}`}>
                    {user.correoElectronico}
                  </td>
                  <td className={styles.positionData}>{user.cargo ?? "-"}</td>
                  <td className={styles.phoneData}>{user.telefono ?? "-"}</td>
                  <td className={styles.statusData}>
                    {user.compradorActivo
                      ? t("pages.reports.active")
                      : t("pages.reports.inactive")}
                  </td>
                  <td className={styles.dateData}>
                    {user.fechaDeDesactivacionComprador
                      ? user.fechaDeDesactivacionComprador.toLocaleDateString()
                      : "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BuyerCompanyReportTable;
